import { render, staticRenderFns } from "./PxCamposCotacaoProdutosViewCasaShopping.vue?vue&type=template&id=540c40f2&"
import script from "./PxCamposCotacaoProdutosViewCasaShopping.vue?vue&type=script&lang=js&"
export * from "./PxCamposCotacaoProdutosViewCasaShopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
